import {RouteDescriptor} from "../../RouteDescriptor";
import {Route} from "../../Route";
import {SettingsPage} from "../../../../../pages/Lk/Shared/Settings/SettingsPage";
import {groupProfile} from "../../../roles/groups";
import {PageGroupMessages, PageGroups} from "../../pageGroups";
import {defineMessage} from "react-intl";

const SettingsRouteTitleMessage = defineMessage({
  id: "settingsRoute.title",
  defaultMessage: "Settings",
})

export const settings: RouteDescriptor<Route.settings> = {
  route: Route.settings,
  render: SettingsPage,
  title: SettingsRouteTitleMessage,
  path: '/lk/settings',
  allowRoles: [
    ...groupProfile
  ],
  redirectToHomeRoles: [
  ],
  showInSidebar: true,
  group: PageGroups.PROFILE,
  groupTitle: PageGroupMessages.profile,
}

